import { render, staticRenderFns } from "./range.vue?vue&type=template&id=35dc0303&scoped=true&"
import script from "./range.vue?vue&type=script&lang=ts&"
export * from "./range.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc0303",
  null
  
)

export default component.exports